export const DISTANCE_LEARNING_TIMETABLE = 'DISTANCE_LEARNING_TIMETABLE'
// export const DISTANCE_LEARNING_TIMETABLE_UPDATED = 'DISTANCE_LEARNING_TIMETABLE_UPDATED'
export const DISTANCE_LEARNING_TIMETABLE_ALL = 'DISTANCE_LEARNING_TIMETABLE_ALL'
// export const DISTANCE_LEARNING_TIMETABLE_GENERATE = 'distanceLearningTimetableGenerate'
export const DISTANCE_LEARNING_TIMETABLE_GENERATE_UPDATED = 'DISTANCE_LEARNING_TIMETABLE_GENERATE_UPDATED'
export const DISTANCE_LEARNING_TIMETABLE_UPDATE_STATUS = 'DISTANCE_LEARNING_TIMETABLE_UPDATE_STATUS'
export const DISTANCE_LEARNING_TIMETABLE_HOURS_REPORT = 'DISTANCE_LEARNING_TIMETABLE_HOURS_REPORT'
